// extracted by mini-css-extract-plugin
export default {"wrapper":"AdsPanel_wrapper__X9Lzr","switchRow":"AdsPanel_switchRow__ARaSg","label":"AdsPanel_label__ipf27","actions":"AdsPanel_actions__z73ym"};